// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.area_mcNDh {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9fafb;
}

.content_V2OnW {
  display : flex;
  flex-direction : row;
  align-items : center;
  justify-content: flex-start;
  width: 60%;
  height: 70%;
  background-color: #ffffff;
  box-shadow: rgba(41, 50, 61, 0.16) 0px 1px 3px;
}

.content_V2OnW > * { 
  margin : var( --size-padXLarge, 24px );
}

.fontIcon_rNLWZ {
  font-size : 200px;
  color : var( --color-lostColor, var( --color-brand800, #333333 ) );
  text-align: center;
  width: 40%;
}

.continue_jH5AS {
  margin-top : var( --size-padLarge, 16px );
}

@media ( max-width: 767px ) {
  .content_V2OnW {
    width: 90%;
    flex-direction: column;
    justify-content: flex-start;
    height: auto;
  }

  .fontIcon_rNLWZ {
    width: auto;
    text-align: left;
    align-self: flex-start;
    justify-self: baseline;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/screens/support/ForbiddenScreen.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,kEAAkE;EAClE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;IACtB,2BAA2B;IAC3B,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;EACxB;AACF","sourcesContent":[".area {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f9fafb;\n}\n\n.content {\n  display : flex;\n  flex-direction : row;\n  align-items : center;\n  justify-content: flex-start;\n  width: 60%;\n  height: 70%;\n  background-color: #ffffff;\n  box-shadow: rgba(41, 50, 61, 0.16) 0px 1px 3px;\n}\n\n.content > * { \n  margin : var( --size-padXLarge, 24px );\n}\n\n.fontIcon {\n  font-size : 200px;\n  color : var( --color-lostColor, var( --color-brand800, #333333 ) );\n  text-align: center;\n  width: 40%;\n}\n\n.continue {\n  margin-top : var( --size-padLarge, 16px );\n}\n\n@media ( max-width: 767px ) {\n  .content {\n    width: 90%;\n    flex-direction: column;\n    justify-content: flex-start;\n    height: auto;\n  }\n\n  .fontIcon {\n    width: auto;\n    text-align: left;\n    align-self: flex-start;\n    justify-self: baseline;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"area": `area_mcNDh`,
	"content": `content_V2OnW`,
	"fontIcon": `fontIcon_rNLWZ`,
	"continue": `continue_jH5AS`
};
export default ___CSS_LOADER_EXPORT___;
